export enum AccountTypes {
    ADMIN = 0,
    CASE_MANAGER = 1,
    EMPLOYER_OF_WORK_COMP_PATIENT = 2,
    INSURANCE_ADJUSTER = 3,
    REFERRAL_PARTNER = 4
}